import { render, staticRenderFns } from "./AdminTagRoles.vue?vue&type=template&id=468ef034"
import script from "./AdminTagRoles.vue?vue&type=script&lang=js"
export * from "./AdminTagRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports